import BaseUseCase from "../../base_use_case.js";

class UpdateCurrentUserUseCase extends BaseUseCase {

  execute(params) {
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/users/current_user`,
      data: this.wrapParams(params, "user")
    });
  }
}

const instance = new UpdateCurrentUserUseCase();
export default instance;